module.exports = __webpack_public_path__ + "media/review-badges/rank-1-9a58157c.svg";